var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.768,
    height: 30.249,
    viewBox: "0 0 115.768 30.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M157.63,1005a21.743,21.743,0,0,1-1.965,3.669c-1.277,1.943-3.075,4.362-5.3,4.383-1.981.018-2.489-1.289-5.177-1.275s-3.249,1.3-5.23,1.279c-2.229-.021-3.933-2.205-5.21-4.148-3.569-5.433-3.942-11.809-1.741-15.2a7.9,7.9,0,0,1,6.352-3.819c2.362,0,3.848,1.3,5.8,1.3,1.894,0,3.049-1.3,5.78-1.3a7.708,7.708,0,0,1,5.811,3.068A6.649,6.649,0,0,0,157.63,1005Z",
    transform: "translate(-131.637 -982.804)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(12.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M184.942,967.266a6.631,6.631,0,0,0,1.472-4.911,7.165,7.165,0,0,0-4.624,2.487,6.155,6.155,0,0,0-1.511,4.79A6.046,6.046,0,0,0,184.942,967.266Z",
    transform: "translate(-180.207 -962.355)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(31.753 0.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(0 10.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M260.194,1004.42l-5.112,15.049h2.341l1.526-4.621h4.95l1.57,4.621h2.406l-5.134-15.049Zm1.213,2.474c.173.672.359,1.369.6,2.123l1.378,3.99h-3.921l1.359-4.016C261.028,1008.34,261.224,1007.637,261.407,1006.894Z",
    transform: "translate(-255.082 -1004.18)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M313.807,1019.586a4.26,4.26,0,0,0-3.62,1.737l-.091-1.5h-2.082l.012.191c.062.932.087,1.959.087,3.432v11.6h2.277v-5.413a4,4,0,0,0,3.112,1.337,4.694,4.694,0,0,0,3.45-1.467,6.22,6.22,0,0,0,1.523-4.379,6.057,6.057,0,0,0-1.323-4A4.332,4.332,0,0,0,313.807,1019.586Zm-.567,1.885c2.03,0,2.938,1.881,2.938,3.743,0,2.4-1.159,3.9-3.025,3.9a2.76,2.76,0,0,1-2.682-2.113,2.9,2.9,0,0,1-.081-.737v-1.831a3.425,3.425,0,0,1,.072-.562c.011-.062.024-.124.033-.185A2.883,2.883,0,0,1,313.24,1021.471Z",
    transform: "translate(-294.399 -1015.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M359.388,1019.586a4.262,4.262,0,0,0-3.62,1.737l-.091-1.5H353.6l.012.191c.062.933.088,1.959.088,3.432v11.6h2.277v-5.413a4,4,0,0,0,3.111,1.337,4.7,4.7,0,0,0,3.452-1.467,6.228,6.228,0,0,0,1.523-4.379,6.058,6.058,0,0,0-1.324-4A4.331,4.331,0,0,0,359.388,1019.586Zm-.567,1.885c2.029,0,2.937,1.881,2.937,3.743,0,2.4-1.16,3.9-3.024,3.9a2.76,2.76,0,0,1-2.682-2.113,2.907,2.907,0,0,1-.08-.737v-1.831a3.378,3.378,0,0,1,.073-.564c.011-.062.023-.123.033-.183A2.881,2.881,0,0,1,358.822,1021.471Z",
    transform: "translate(-328.256 -1015.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M417.565,1010.1c-2.125-.823-2.806-1.47-2.806-2.666,0-1.007.8-2.022,2.588-2.022a5.175,5.175,0,0,1,2.673.671l.193.119.643-1.9-.127-.074a6.6,6.6,0,0,0-3.316-.744c-2.9,0-4.932,1.714-4.932,4.167,0,1.979,1.27,3.362,4,4.353,1.932.722,2.652,1.462,2.652,2.73,0,1.436-1.11,2.327-2.894,2.327a6.231,6.231,0,0,1-3.282-.931l-.2-.127-.611,1.944.112.074a7.8,7.8,0,0,0,3.848.989c3.913,0,5.3-2.386,5.3-4.429C421.406,1012.48,420.294,1011.181,417.565,1010.1Z",
    transform: "translate(-371.744 -1003.488)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M452.913,1010.439l-2.233.7v1.892h-1.635v1.82h1.635v5.574a4.26,4.26,0,0,0,.788,2.889,2.918,2.918,0,0,0,2.2.865,5.366,5.366,0,0,0,1.76-.272l.128-.045-.109-1.823-.218.067a3.428,3.428,0,0,1-1.059.122c-.882,0-1.259-.558-1.259-1.869v-5.509h2.747v-1.82h-2.747Z",
    transform: "translate(-399.153 -1008.651)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M481.072,1019.586c-3.186,0-5.41,2.378-5.41,5.781,0,3.3,2.153,5.606,5.236,5.606h.021c2.606,0,5.41-1.816,5.41-5.8a5.752,5.752,0,0,0-1.451-4.027A5.067,5.067,0,0,0,481.072,1019.586Zm-.066,1.8c2.048,0,2.981,2,2.981,3.853,0,2.282-1.273,3.939-3.024,3.939h-.022c-1.727,0-2.98-1.629-2.98-3.873C477.961,1023.352,478.9,1021.383,481.006,1021.383Z",
    transform: "translate(-418.923 -1015.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M527.878,1019.692l-.136-.035a2.187,2.187,0,0,0-.566-.071,3.249,3.249,0,0,0-2.855,1.833l-.067-1.593h-2.043l.013.191c.061.9.086,1.913.086,3.279l-.021,7.438h2.277v-5.8a5.857,5.857,0,0,1,.063-.882,2.517,2.517,0,0,1,2.4-2.294,5.829,5.829,0,0,1,.611.038l.244.025Z",
    transform: "translate(-453.499 -1015.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M549.279,1019.5c-3.031,0-5.148,2.422-5.148,5.889,0,3.339,2.106,5.5,5.366,5.5a8.731,8.731,0,0,0,3.6-.692l.137-.062-.438-1.7-.19.077a7.062,7.062,0,0,1-2.852.51,3.165,3.165,0,0,1-3.41-3.3l7.349.022.03-.145a5.056,5.056,0,0,0,.068-.95C553.8,1022.276,552.613,1019.5,549.279,1019.5Zm-.151,1.732a2.247,2.247,0,0,1,1.671.638,3.241,3.241,0,0,1,.784,2.12H546.39A2.906,2.906,0,0,1,549.127,1021.234Z",
    transform: "translate(-469.78 -1015.383)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M255.082,964.029a16.62,16.62,0,0,1,2.184-.148,4.873,4.873,0,0,1,3.206.877,3.117,3.117,0,0,1,1.127,2.568,3.6,3.6,0,0,1-1.139,2.768,5.283,5.283,0,0,1-3.511,1.025,15.748,15.748,0,0,1-1.867-.085Zm1.034,6.309a7.3,7.3,0,0,0,1.033.043c2.184.01,3.37-1.1,3.37-3.022.012-1.7-1.045-2.748-3.205-2.748a6.5,6.5,0,0,0-1.2.095Z",
    transform: "translate(-255.082 -963.553)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M286.788,976.787a2.567,2.567,0,0,1-2.724-2.631,2.638,2.638,0,0,1,2.818-2.716,2.547,2.547,0,0,1,2.736,2.621,2.648,2.648,0,0,1-2.817,2.726Zm.035-.7a1.82,1.82,0,0,0,1.726-2,1.738,1.738,0,1,0-1.738,2Z",
    transform: "translate(-276.609 -969.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M308.957,971.891l.763,2.589c.152.571.305,1.109.411,1.638h.035c.129-.518.317-1.067.505-1.627l.928-2.6h.869l.881,2.557c.211.6.376,1.152.5,1.67h.035a14.166,14.166,0,0,1,.434-1.659l.81-2.568h1.022l-1.832,5.114h-.939l-.869-2.441a16.769,16.769,0,0,1-.505-1.691h-.023a14.02,14.02,0,0,1-.517,1.7l-.915,2.43h-.939l-1.715-5.114Z",
    transform: "translate(-294.314 -969.503)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M343.875,972.94c0-.539-.012-.962-.047-1.384h.916l.058.835h.024a2.152,2.152,0,0,1,1.878-.951,1.945,1.945,0,0,1,2.008,2.177v3.054H347.68v-2.948c0-.824-.341-1.521-1.316-1.521a1.474,1.474,0,0,0-1.385.951,1.254,1.254,0,0,0-.071.433v3.085h-1.033Z",
    transform: "translate(-321 -969.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M369.346,962.607h1.033v7.5h-1.033Z",
    transform: "translate(-339.954 -962.607)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M381.156,976.787a2.567,2.567,0,0,1-2.724-2.631,2.638,2.638,0,0,1,2.818-2.716,2.547,2.547,0,0,1,2.735,2.621,2.648,2.648,0,0,1-2.818,2.726Zm.035-.7a1.82,1.82,0,0,0,1.727-2,1.738,1.738,0,1,0-1.738,2Z",
    transform: "translate(-346.703 -969.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M407.807,975.445a7.7,7.7,0,0,0,.083,1.225h-.928l-.094-.644h-.035a2.185,2.185,0,0,1-1.738.76,1.549,1.549,0,0,1-1.738-1.469c0-1.236,1.221-1.913,3.416-1.9v-.106c0-.422-.129-1.194-1.291-1.183a2.966,2.966,0,0,0-1.491.38l-.235-.623a4,4,0,0,1,1.879-.444,1.9,1.9,0,0,1,2.172,2.092Zm-1.009-1.384c-1.127-.021-2.407.158-2.407,1.151a.864.864,0,0,0,.963.888,1.433,1.433,0,0,0,1.4-.856.851.851,0,0,0,.047-.3Z",
    transform: "translate(-365.217 -969.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M430.815,962.607v6.182c0,.454.013.972.047,1.321h-.927l-.047-.887h-.024a2.126,2.126,0,0,1-1.926,1,2.439,2.439,0,0,1-2.443-2.6,2.55,2.55,0,0,1,2.548-2.747,1.955,1.955,0,0,1,1.715.772h.023v-3.044Zm-1.033,4.47a1.544,1.544,0,0,0-.047-.4,1.493,1.493,0,0,0-1.491-1.067,1.75,1.75,0,0,0-1.7,1.966,1.7,1.7,0,0,0,1.679,1.9,1.538,1.538,0,0,0,1.514-1.109,1.446,1.446,0,0,0,.047-.4Z",
    transform: "translate(-381.661 -962.607)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M463.644,976.787a2.567,2.567,0,0,1-2.724-2.631,2.639,2.639,0,0,1,2.818-2.716,2.547,2.547,0,0,1,2.736,2.621,2.648,2.648,0,0,1-2.817,2.726Zm.036-.7a1.819,1.819,0,0,0,1.726-2,1.737,1.737,0,1,0-1.738,2Z",
    transform: "translate(-407.973 -969.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M487.445,972.94c0-.539-.012-.962-.047-1.384h.916l.059.835h.023a2.152,2.152,0,0,1,1.878-.951,1.945,1.945,0,0,1,2.008,2.177v3.054h-1.034v-2.948c0-.824-.34-1.521-1.315-1.521a1.476,1.476,0,0,0-1.386.951,1.26,1.26,0,0,0-.07.433v3.085h-1.033Z",
    transform: "translate(-427.641 -969.168)",
    fill: "#f2f2f2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.8f7c450f693fc5e86ae4e6c15d166405.svg";
export { ForwardRef as ReactComponent };